















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  companiesCollection,
  safetyCollection,
  wellControlCollection,
} from '@/firebaseConfig.ts';
import { auth } from '@/firebaseConfig.ts';
import { User } from '../../types';

@Component
export default class Login extends Vue {
  incident: Object | undefined = {};
  comments: Array<Object> = [];

  get hasPhoto(): boolean {
    return (
      (this.incident &&
        this.incident.hasOwnProperty('photos') &&
        this.incident['photos'].length > 0) ||
      false
    );
  }

  get hasMedia(): boolean {
    return this.hasPhoto || this.hasVideos;
  }

  get hasVideos(): boolean {
    return (
      (this.incident &&
        this.incident.hasOwnProperty('videos') &&
        this.incident['videos'].length > 0) ||
      false
    );
  }

  async mounted() {
    const postId = this.$route.params.id;
    const docRef = await wellControlCollection.doc(postId);
    docRef.onSnapshot(snapshot => {
      if (snapshot.exists) {
        const data = snapshot.data();
        console.log(data);
        this.incident = data;
        docRef
          .collection('comments')
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              console.log(doc);
              this.comments.push(doc.data());
            });
          });
      } else {
        console.log('Snapshot does not exist');
      }
    });
  }
}
